import '../scss/shop.kfzteile-com.scss';

import '../js/shop.js';
